<template>
  <div class="card is-full-width-height">
    <gmap-map
      :center="constantes.CENTER_DEFAULT"
      :zoom="constantes.ZOOM_DEFAULT"
      :options="{
        mapTypeControlOptions: constantes.MAP_TYPE_CONTROL_OPTIONS,
      }"
      class="googleMap"
      @tilesloaded="actionMapIsLoaded"
      @zoom_changed="getZoom = $event"
      ref="mapCartoGeneral">
      <div v-if="loadMap">
        <gmap-marker
          v-if="pdv"
          :position="pdv.adressePostale.coordonnees"
          :icon="pdv.iconMarker">
        </gmap-marker>

    
        <!-- Marker panneau -->
        <gmap-marker
          v-for="(markerPanneau, index) in markersPanneaux"
          :key="index + 'panneau'"
          :position="markerPanneau.adresse.coordonnees"
          :icon="markerPanneau.iconMarker"
          @click="affichePanneau(index)">
        </gmap-marker>

      <!-- Liste des concurrents -->

        <gmap-marker
          v-for="(marker, index) in listeMarkerPdvConcurrents"
          :key="`con${index}`"
          :position="marker.data.coordonnees"
          :icon="marker.iconMarker">
        </gmap-marker>

      </div>
      <!-- Marker point de vente -->
      
    </gmap-map>
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
      :duration="300"
      v-on:after-enter="bg = true"
      v-on:after-leave="bg = false">
      <DetailPanneau
        v-if="detailPanneau"
        @close="detailPanneau = null"
        :detailPanneau="detailPanneau"
        :bg="bg"/>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import siteConfig from '@/configurations/siteConfig';
import {
  CENTER_DEFAULT, ZOOM_DEFAULT,
  MAP_TYPE_CONTROL_OPTIONS,
  STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME,
} from '@/configurations/configurationCarto';
import {
  iconMarkerInfoBulle,
  getIconPdvData,
} from '@/services/gestionIconMarker/iconColorGetter';
import gestionErreur from '@/services/general/gestionErreur';
import { isCategorieHonoraire } from '@/services/recommandation/panneauManager';
import DetailPanneau from '@/components/portail/blocProduits/DetailPanneau';
import { COULEUR_PANNEAU_SOUS_CONTRAT } from '@/configurations/configPanneau';
import { SET_ICON_MARKER_PDV } from '@/store/modules/recommandation-mutation-type';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  components: { DetailPanneau },
  data() {
    return {
      getZoom: 0,
      isLoading: false,
      isMapLoaded: false,
      isMountedLoaded: false,
      markersPanneaux:[],
      bg: false,
      detailPanneau: null,
      listeMarkerPdvConcurrents: [],
      constantes: {
        ZOOM_DEFAULT,
        CENTER_DEFAULT,
        MAP_TYPE_CONTROL_OPTIONS,
      },
    };
  },
  watch: {
    getPdvConcurrentsSelected: {
      async handler() {
        await this.genererListePdvConcurrentAvecMarker();
        this.fitBounds();
      },
    },
  },
  computed: {
    ...Recommandation.mapGetters({
      pdv: 'pdv',
      getPanneaux: 'panneaux',
      getPdvConcurrentsSelected: 'pdvConcurrentSelected',
    }),
    loadMap() {
      return this.isMapLoaded && this.isMountedLoaded;
    },
  },
  methods: {
    ...Recommandation.mapMutations({
      setIconMarkerPdv: SET_ICON_MARKER_PDV,
    }),
    async genererIconMarkerPdv() {
      const resIcon = await getIconPdvData(this.pdv.urlLogo);
      this.setIconMarkerPdv(resIcon.icon);
    },
    async getIconPanneau(panneau, index) {
      const color = panneau.estPanneauSousContrat
        ? COULEUR_PANNEAU_SOUS_CONTRAT
        : panneau.categorie?.couleur;
      const icon = await iconMarkerInfoBulle(color, panneau.azimut, index + 1);
      return icon;
    },
    async levelZoom() {
      await this.$refs.mapCartoGeneral.$mapPromise;
      await this.fitBounds();
    },
    async genererListePanneauMarker() {
      const panneauxFilter = this.getPanneaux.filter(p => !isCategorieHonoraire(p.categorie));
      const liste = cloneDeep(panneauxFilter);
      const req = liste.map((el, i) => this.getIconPanneau(el, i));
      const res = await Promise.all(req);
      liste.forEach((el, i) => {
        el.iconMarker = res[i];
      });
      this.markersPanneaux = liste;
    },
    async genererListePdvConcurrentAvecMarker() {
      const { taille } = siteConfig.default.pdvConcurent;
      const liste = cloneDeep(this.getPdvConcurrentsSelected);
      const req = [];
      liste.forEach(el => {
        req.push(getIconPdvData(el.data.urlLogo, taille));
      });
      const res = await Promise.all(req);
      liste.forEach((el, i) => {
        el.iconMarker = res[i].icon;
      });
      this.listeMarkerPdvConcurrents = liste;
    },
    affichePanneau(i) {
      this.detailPanneau = this.markersPanneaux[i];
    },
    async fitBounds() {
      await this.$gmapApiPromiseLazy();
      const bounds = new google.maps.LatLngBounds();
      bounds.extend(this.pdv.adressePostale.coordonnees);
      if (this.markersPanneaux.length) {
        this.markersPanneaux.forEach(el => {
          bounds.extend(el.adresse.coordonnees);
        })
      }
      if (this.listeMarkerPdvConcurrents.length) {
        this.listeMarkerPdvConcurrents.forEach(el => {
          bounds.extend(el.data.coordonnees);
        });
      }

      this.$refs.mapCartoGeneral.fitBounds(bounds);
      const map = await this.$refs.mapCartoGeneral.$mapPromise;
      map.setZoom(this.getZoom - 1);
      return '';
    },
    async actionMapIsLoaded() {
      if (!this.isMapLoaded) {
        await this.initCarto();
        this.isMapLoaded = true;
      }
    },
    async initCarto() {
      if (!this.$refs.mapCartoGeneral) return;
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        await this.$gmapApiPromiseLazy();
        const map = await this.$refs.mapCartoGeneral.$mapPromise;
        const styleMap = new google.maps.StyledMapType(STYLE_MAPS_POI_HIDDEN, {
          name: MAP_TYPE_NAME,
        });
        map.mapTypes.set('styled_map', styleMap);
        await this.levelZoom();
      } catch (error) {
        gestionErreur('Erreur initialisation map');
        throw error;
      } finally {
        loadingComponent.close();
      }
    }
  },
  async mounted () {
    try {
      await this.$gmapApiPromiseLazy();
      await this.genererIconMarkerPdv();
      await Promise.all([
        this.genererListePanneauMarker(),
        this.genererListePdvConcurrentAvecMarker(),
      ]);
      await this.initCarto();
      this.isMountedLoaded = true;
    } catch (error) {
      gestionErreur('Erreur initialisation mounted');
      throw error;
    }
  },
};
</script>
